module.exports = "/_next/static/images/strategic-planning-training-service-4-35a2a19b31430afaa2adcd4c8a4d3891.webp";